import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

/* !! Cet intercptor est un 'workaround' pour un bug concernant Webkit/iOS > 26.6 !!

# Le bug en question (voir https://gitea.abelium-collectivite.lan/Dominoweb2/Portail/issues/975) :
Lors de l'envoi de ficher (document perso, ged, pièce jointes, etc...) depuis un périphérique sous iOS 26.6.xx
la requête envoyée par le navigateur est vide : content-lenght = 0. Le serveur ne voit donc pas de fichier et renvoit donc
l'erreur "Le fichier n'a pas été trouvé".
Il s'agit à priori d'un bug de Webkit, et donc il concerne :
- tous les navigateurs sur iOS, puisque Apple impose son moteur de rendu à tous les navigateurs sur sa plateforme !
- les requetes contenant un FormData qui contiennent un fichier et qui sont interceptées par un service worker
  NB : Le service worker Angular intercepte toutes les requêtes même les POST et PUT, même s'il ne les met pas en cache

Pour contourner le bug, nous allons donc "zapper" le service worker en ajoutant le paramètre 'ngsw-bypass=true' dans l'url.
Juste pour info, Une autre solution consiste à lire le contenu du 'file' pour le transformer en blob afin de créer une copie en
mémoire du fichier avant de construire le FormData, et d'utiliser append() plutôt que set() pour construire le formData.
Cette autre solution fonctionne aussi, mais nous oblige à le faire à chaque endroit ou l'on construit un FormData avec un 'file' , c'est à dire
dans plusieurs services ou composants...
=> Trop fastidieux pour un bug d'Apple qui sera surement corrigé à l'avenir.
=> Donc on garde la solution de zapper le service worker qui de toutes façon me parait plus sûre puisque le service worker
    n'a pas besoin de traiter les requêtes POST ou PUT

Voici des tickets qui parlent de ce bug :
- https://bugs.webkit.org/show_bug.cgi?id=320904
- https://bugs.webkit.org/show_bug.cgi?id=319396
- https://bugs.webkit.org/show_bug.cgi?id=319985

*/

@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const isMultipart =
      req.body instanceof FormData;

    if (!isMultipart) {
      return next.handle(req);
    }

    if (req.url.includes('ngsw-bypass=')) {
      return next.handle(req);
    }

    const separator =
      req.url.includes('?') ? '&' : '?';

    return next.handle(
      req.clone({
        url: `${req.url}${separator}ngsw-bypass=true`
      })
    );
  }
}
